module.exports = __webpack_public_path__ + "media/assets/svg/logos/leanbit_logo-7b6e5657809a0b4fefe8d09ce140bbe7.svg";